import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  content: React.ReactNode;
  image?: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  title,
  content,
  image,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-zinc-800 rounded-lg overflow-hidden bg-zinc-900/50 mb-3" data-id="element-189" data-mp="28cyhse42jpdr">
      {image && <div className="relative h-32 md:h-40 w-full overflow-hidden" data-id="element-190" data-mp="2i4usconcd7yv">
          <img src={image} alt={title} className="w-full h-full object-cover object-top" data-id="element-191" data-mp="2i4mfuxv4s4o7" />
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/40 to-transparent" data-id="element-192" data-mp="2s3bmfuhku2p5" />
        </div>}
      <button className="w-full flex items-center justify-between p-4 text-left focus:outline-none" onClick={onClick} data-id="element-193" data-mp="11rnsjvsy99ks">
        <span className="font-semibold text-white pr-4" data-id="element-194" data-mp="xr3yj13oam2v">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-195" data-mp="3g5ey4jn5ngib">
          <ChevronDown className="w-5 h-5 text-[#c6ff2e]" data-id="element-196" data-mp="3q1rr1favlqc0" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-197" data-mp="3usqecyua7oor">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-198" data-mp="3uv343y6a73cd">
            <div className="p-4 pt-0 text-zinc-400 text-sm md:text-base border-t border-zinc-800/50 mt-2" data-id="element-199" data-mp="hk42gmqdgh8a">
              {content}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    title: string;
    content: React.ReactNode;
    image?: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full" data-id="element-200" data-mp="2lc4f7we3tgn6">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} content={item.content} image={item.image} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-201" data-mp="2gbp3f99h0h7b" data-mpi={index} />)}
    </div>;
}